import { useState, useEffect } from 'react';

// Compute sizes based on current window width. Safe for SSR.
const getSizes = () => {
  if (typeof window === 'undefined') {
    return { isMobile: false, isTablet: false, isDesktop: true };
  }
  const width = window.innerWidth;
  return {
    isMobile: width < 768,
    isTablet: width >= 768 && width < 1024,
    isDesktop: width >= 1024,
  };
};

const useResponsive = () => {
  // Initialize from current viewport to avoid first-render mismatch/flash
  const [screenSize, setScreenSize] = useState(getSizes);

  useEffect(() => {
    const update = () => setScreenSize(getSizes());

    // Initial check (covers Storybook viewport changes on mount)
    update();

    // Listen to both resize and media query changes for reliability
    const mqlMobile = window.matchMedia('(max-width: 767.98px)');
    const mqlTablet = window.matchMedia('(min-width: 768px) and (max-width: 1023.98px)');

    window.addEventListener('resize', update);
    mqlMobile.addEventListener('change', update);
    mqlTablet.addEventListener('change', update);

    return () => {
      window.removeEventListener('resize', update);
      mqlMobile.removeEventListener('change', update);
      mqlTablet.removeEventListener('change', update);
    };
  }, []);

  return screenSize;
};

export default useResponsive;
